import Backend from "./Backend";
import {UserInfo} from "../model/user/UserInfo";
import {UserRole} from "../model/user/UserRole";

class UserApi {
    public fetchUserInfo(): Promise<UserInfo> {
        return Backend.get('/api/v1/user');
    }

    public selectNewRole(newRole: UserRole): Promise<void> {
        return Backend.post(`/api/v1/user/role/current/${newRole}`, {});
    }
}

export const userApi = new UserApi();